package net.bothosting.docs.pages.hosting_in_bot_hosting_net

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSet_up_a_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("hosting_in_bot_hosting_net/set_up_a_server.md", FrontMatterElement.Builder { addScalar("icon", "gear"); }))
}

@Page("/hosting_in_bot_hosting_net/set-up-a-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Set_up_a_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("set-up-a-server") }) {
        org.jetbrains.compose.web.dom.Text("Set Up a Server")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("before-you-start") }) {
        org.jetbrains.compose.web.dom.Text("Before you start")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Make sure you have created an account - ")
            com.varabyte.kobweb.silk.components.navigation.Link("create-an_account.md") {
                org.jetbrains.compose.web.dom.Text("Create an Account")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Make sure you have created a server - ")
            com.varabyte.kobweb.silk.components.navigation.Link("create-a_server.md") {
                org.jetbrains.compose.web.dom.Text("Create a Server")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("set-up-a-server-2") }) {
        org.jetbrains.compose.web.dom.Text("Set Up a Server")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The Pterodactyl panel, which we use for the control.bot-hosting.net site, does not offer a shell page to run commands. The console does not support them either, so you will not be able to run commands like ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("npm install discord.js")
            }
            org.jetbrains.compose.web.dom.Text(" or ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("pip install discord.py")
            }
            org.jetbrains.compose.web.dom.Text(". Additionally, uploading modules or packages is ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("NOT")
            }
            org.jetbrains.compose.web.dom.Text(" recommended, as it can create version or software issues. There are different ways to install modules and packages.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now that you have created a server, you should be able to view it on the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Manage Servers")
        }
        org.jetbrains.compose.web.dom.Text(" page. Click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Manage Server")
        }
        org.jetbrains.compose.web.dom.Text(" on it.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (6).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can then view your server in the control panel. This is where you will upload files, start or stop your server, and configure it.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (7).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If this is your first time entering the control panel, you will be prompted to log in with Discord again. Once logged in, you should be able to see your server in the control panel. Select it.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (8).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You should now see your server like this. Along the top, you will see tabs to control different aspects of the server. The first thing you should do is upload your files.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("upload-and-unarchive-files") }) {
        org.jetbrains.compose.web.dom.Text("Upload and Unarchive Files ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#e0w5sxsclpw");attr("id", "e0w5sxsclpw")}) {
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" If you want to pull files from a Git repository, please refer to ")
            com.varabyte.kobweb.silk.components.navigation.Link("/hosting_in_bot_hosting_net/connect-to-your-servers-files-with-sftp") {
                org.jetbrains.compose.web.dom.Text("this guide")
            }
            org.jetbrains.compose.web.dom.Text(" instead.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There are 2 ways to upload your files. You only need one:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Files tab:")
            }
            org.jetbrains.compose.web.dom.Text(" You can upload your files in the server's Files tab.")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (9).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.CAUTION, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("IMPORTANT:")
            }
            org.jetbrains.compose.web.dom.Text(" You should ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("always")
            }
            org.jetbrains.compose.web.dom.Text(" keep the original files on your local device or cloud.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("We are not a cloud storage service: if your server/account is deleted, your files are gone.")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("SFTP:")
            }
            org.jetbrains.compose.web.dom.Text(" Secure File Transfer Protocol. You can use this method to manage your server files directly from a program on your computer. If you want to use SFTP, you can find your credentials in the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Settings")
            }
            org.jetbrains.compose.web.dom.Text(" tab in the control panel navbar for your server.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you want to upload your files using the Files tab and file selector, click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Files")
        }
        org.jetbrains.compose.web.dom.Text(" in the navbar at the top of your server, then click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Upload")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" If you are using Node.js, you do not need to upload your ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("node_modules")
            }
            org.jetbrains.compose.web.dom.Text(" folder, as the server can automatically install your packages as long as you upload your ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" file.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you are using Python, you do not need to upload your ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(".cache")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(".local")
        }
        org.jetbrains.compose.web.dom.Text(" folders, as the server can automatically install your packages as long as you upload your ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("requirements.txt")
        }
        org.jetbrains.compose.web.dom.Text(" file.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You should upload your files in a compressed format such as ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(".zip")
        }
        org.jetbrains.compose.web.dom.Text(" or ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(".gz")
        }
        org.jetbrains.compose.web.dom.Text(". Once the archive is on the server, click the three dots next to the file and select ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Unarchive")
        }
        org.jetbrains.compose.web.dom.Text(" to extract it.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (10).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you are using an archive, your files will most likely decompress into a folder. You should move your files out of that folder. First, open the folder you just extracted.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (11).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Then select all the files using the checkbox next to them. You should now see a menu appear on your server where you can click ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Move")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (12).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This will open a modal where you can enter the path to move the files to. You can enter a relative path here, so to move the files out of the folder, simply enter ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("..")
        }
        org.jetbrains.compose.web.dom.Text(" to move them back one directory. Then, to complete the move, press Enter or click the move button.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (13).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Finally, you can delete the archive and folder on your server to free up space. Of course, if your files are already out of the folder, you do not need to follow those additional steps.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("final-configuration") }) {
        org.jetbrains.compose.web.dom.Text("Final Configuration ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#q5mpitoqo0z");attr("id", "q5mpitoqo0z")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You should review the startup configuration, found in the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Startup")
        }
        org.jetbrains.compose.web.dom.Text(" tab on your server control panel, before your bot is ready to go. There are some notable configuration options.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You will see an option similar to ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Bot <language> file")
        }
        org.jetbrains.compose.web.dom.Text(" or ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("JAR FILE")
        }
        org.jetbrains.compose.web.dom.Text(". This is the file that the server will start with. When developing your bot, you will have a main file that is used to start the bot and import all other files. This is what you must enter here, so make sure it is correct.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" If the file that starts the bot is not in the main directory and you cannot move it, please specify the path to the file in the field.")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image (14).png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Additionally, if you are running a Python or Node.js server, you need to make sure the server knows which modules, packages, or libraries your code requires.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("node-js-packages-installation") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Node.js Packages Installation")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#id-0sliscetlmx");attr("id", "id-0sliscetlmx")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("There are 2 ways to install Node.js packages:")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When you start the server, the startup command checks for a file named ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" and installs modules using the names and versions defined in it. There are 2 ways to get that file:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("From the folder where you developed your bot. It is most likely generated by the application you use for coding.")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://docs.npmjs.com/creating-a-package-json-file") {
                org.jetbrains.compose.web.dom.Text("Create it manually with this guide")
            }
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("In your server control panel, open the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Startup")
            }
            org.jetbrains.compose.web.dom.Text(" section. Use ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("ADDITIONAL NODE PACKAGES")
            }
            org.jetbrains.compose.web.dom.Text(" to install extra Node.js packages, separating package names with spaces. ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Write only the package name, not the npm command.")
            }
        }
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""- npm install package (this can't be used)
+ package
""") } }
    org.jetbrains.compose.web.dom.H3(attrs = { id("common-errors-related-to-package-installation") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Common Errors Related to Package Installation")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#c2iqeq5e27f");attr("id", "c2iqeq5e27f")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Error: Cannot find module 'package'")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This error means the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" file does not contain the package, or there was a problem during installation. Check the errors above.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("npm error 404 Not Found - GET https://registry.npmjs.org/")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This usually means the package you are trying to install does not exist, you typed it incorrectly, or an error caused the installation to be skipped.")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("python-modules-installation") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Python Modules Installation")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#id-6e752pi312y");attr("id", "id-6e752pi312y")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("There are 2 ways to install Python packages:")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When you start the server, the startup command checks for a file named ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("requirements.txt")
            }
            org.jetbrains.compose.web.dom.Text(" and installs modules using the names and optional versions defined in it. ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://pip.pypa.io/en/stable/reference/requirements-file-format/") {
                org.jetbrains.compose.web.dom.Text("requirements.txt file creation guide")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("In your server control panel, open the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Startup")
            }
            org.jetbrains.compose.web.dom.Text(" section. Use ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("ADDITIONAL PYTHON PACKAGES")
            }
            org.jetbrains.compose.web.dom.Text(" to install extra Python packages, separating package names with spaces.")
        }
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""- pip install package (this can't be used)
+ package
""") } }
    org.jetbrains.compose.web.dom.H3(attrs = { id("common-errors-related-to-package-installation-2") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Common Errors Related to Package Installation")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "#z6xo8w33edw");attr("id", "z6xo8w33edw")}) {
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("ModuleNotFoundError: no module named 'discord'")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("This usually means that you did not declare the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("discord")
            }
            org.jetbrains.compose.web.dom.Text(" module in your requirements file, or the server could not install that module because an earlier error occurred.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("ERROR: Could not find a version that satisfies the requirement package (from versions: none)")
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("The package you are trying to install does not exist.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Your server should now be ready to go!")
    }
}
